<template>
    <div class="addGroup container container-main">
        <div class="content content-regular">
            <!--<div class="page-header-actions">
                    <dx-button :use-submit-behavior="false"
                               type="normal"
                               :text="$t('buttons.edit')"
                               @click="function(){ $router.push({ name: 'dictionaries.branches.edit' }) }">
                    </dx-button>
            </div>-->
            <div class="row">
                <div class="col-xs-12">
                    <form @submit.prevent="detailsBranches">
                        <div class="form-wrapper">
                            <div class="row form-header between-xs middle-xs">
                                <div class="col-xs">
                                    <span class="form-header-title">
                                        {{$t('details.title')}}
                                    </span>
                                </div>
                            </div>
                            <div class="row form-wrapper-row">
                                <div class="col-xs-2">
                                    <label>{{$t('add.label.branch')}}</label>
                                </div>
                                <div class="col-xs-4">
                                    <dx-text-box v-model="Branch"
                                                 :read-only="true">
                                        <dx-validator>
                                            <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 end-xs">
                            <div class="col-xs">
                                <dx-button :use-submit-behavior="false"
                                           type="default"
                                           :text="$t('buttons.back')"
                                           @click="function(){ $router.push({ name: 'dictionaries.branches.index' }) }">
                                </dx-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import DxTextBox from 'devextreme-vue/text-box';
    import DxButton from 'devextreme-vue/button';
    import { DxValidator, DxRequiredRule } from 'devextreme-vue/validator';

    import { mapGetters, mapActions } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    const name = "administrationStores/dictionariesStores/branchesStores/detailsStore";

    export default {
        name: 'branchDetails',
        computed: {
            ...mapGetters(name, ['getForm']),
            ...mapFields(name, [
                'detailsForm.Id',
                'detailsForm.Branch',
            ]),
        },
        methods: {
            ...mapActions(name, ['setDetails']),
        },
        mounted() {
            this.setDetails();
        },
        components: {
            DxTextBox,
            DxButton,
            DxValidator,
            DxRequiredRule
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
